import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Row } from "reactstrap";

const Pagination = ({ data, currentPage, setCurrentPage}) => {
	const handleClick = (e) => {
		setCurrentPage(e);
	};
	const handleprevPage = () => {
		let prevPage = currentPage - 1;
		setCurrentPage(prevPage);
	};
	const handlenextPage = () => {
		let nextPage = currentPage + 1;
		setCurrentPage(nextPage);
	};

	useEffect(() => {
		if (data.length && data.length < currentPage) {
			setCurrentPage(data.length);
		}
	}, [data.length, currentPage, setCurrentPage]);

	const renderPaginationButtons = () => {
		const pageButtons = [];
		let startPage = 1;
		if (data.length <= 5) {
			startPage = 1;
		} else if (currentPage <= Math.ceil(5 / 2)) {
			startPage = 1;
		} else if (currentPage > data.length - Math.floor(5 / 2)) {
			startPage = data.length - 5 + 1;
		} else {
			startPage = currentPage - Math.floor(5 / 2);
		}


		for (let i = startPage; i < startPage + (data.length > 5 ? 5 : data.length); i++) {
			pageButtons.push(
				<React.Fragment key={i}>
					<li className="page-item">
						<Link className={currentPage === i ? "page-link active" : "page-link"} onClick={() => handleClick(i)}>{i}</Link>
					</li>
				</React.Fragment>
			);
		}
		return pageButtons;
	};

	return (
		<React.Fragment>
			<Row className="g-0 justify-content-end">
				<div className="col-sm-auto">
					<ul className="pagination-block pagination pagination-separated flex-wrap justify-content-center justify-content-sm-end mb-sm-0">
						<li className={currentPage <= 1 ? "page-item disabled" : "page-item"}>
							<Link className="h-100 page-link d-flex align-items-center justify-content-center ms-0" onClick={handleprevPage}>
								<i className="bx bx-left-arrow-alt"></i>
							</Link>
						</li>
						{renderPaginationButtons()}
						<li className={currentPage === data.length ? "page-item disabled" : "page-item"}>
							<Link className="h-100 page-link d-flex align-items-center justify-content-center ms-0" onClick={handlenextPage}>
								<i className="bx bx-right-arrow-alt"></i>
							</Link>
						</li>
					</ul>
				</div>
			</Row>
		</React.Fragment>
	);
};

export default Pagination;